export enum TipoResponsable {
  firmaOperadora,
  referenteComercial,
  referenteGestion,
  referenteTecnico,
  ruteador
}